<template>
  <div class="notification-container" v-bind:class="notification_class" v-on:click="make_inactive">
    <popup-notification type="correct" v-bind:title="computedTitle">{{captionState.caption}}</popup-notification>
  </div>
</template>

<script>
  import popup_notification from '../molecules/popup_notification'
  export default {
    props: ['state', 'captionState'],
    components: {
      'popup-notification': popup_notification
    },
    methods: {
      // make reusable (duplicate navbar method)
      make_inactive () {
        let correct = this.$store.state.checkbox.correct
        if (correct === 'correct') {
          this.$store.commit('change_page', 1)
        }
        this.$store.commit('set_notification', {active: false})
        this.$store.commit('set_checkbox', {el: null})
        let checkboxes = document.querySelectorAll('[radio]')
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false
        })
      }
    },
    computed: {
      notification_class () {
        let active = this.$store.state.notification_state.active
        if (active) return ''
        return 'notification-inactive'
      },
      computedTitle () {
        if (this.$store.state.checkbox.correct === 'correct') {
          return this.state.correctTitle
        } else {
          return this.state.incorrectTitle
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .notification-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin-bottom: 72px;
    z-index: 5;
    transition: all 0.8s ease-in-out;
    &.notification-inactive {
      // transform: translateY(calc(105% + 72px));
      margin-bottom: -500px; // IE compatible
      pointer-events: none;
    }
  }
</style>


// WEBPACK FOOTER //
// notification.vue?8c9cc0e6